import Backbone from 'backbone-model';
import { defaults, result, uniqueId } from 'lodash';

import Collection from 'lib/Collection';

import sync from './BackboneSync';

import { Backbone$Attrs } from 'types/typescript/Backbone';

export default class Entity extends Backbone.Model {
  constructor(attrs: any = {}, options: any = {}) {
    super();
    this.cid = uniqueId('c');
    this.attributes = {};
    if (options.collection) {
      this.collection = options.collection;
    }
    let possiblyParsedAttrs = attrs;
    if (options.parse) {
      possiblyParsedAttrs = this.parse(attrs, options) || {};
    }
    const defaultedAttrs = defaults({}, possiblyParsedAttrs, result(this, 'defaults'));
    this.initialize.call(this, defaultedAttrs, options);
    this.set(defaultedAttrs, options);
    this.changed = [];
  }

  fetch(options: Backbone.ModelFetchOptions = {}): Promise<this> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (_model, response) => {
        reject(response);
      };
      super.fetch(options);
    });
  }

  save(attributes: Backbone$Attrs, options: Backbone.ModelSaveOptions = {}): Promise<void> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (_model, response) => {
        reject(response);
      };
      super.save(attributes, options);
    });
  }

  destroy(options: Backbone.ModelDestroyOptions = {}): Promise<void> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = reject;
      super.destroy(options);
    });
  }

  // eslint-disable-next-line
  // @ts-ignore
  sync(...args: any[]) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'IArguments' is not assignable to... Remove this comment to see the full error message
    return sync.apply(this, arguments);
  }

  jasmineToString(): string {
    return this.constructor.name + ' ' + JSON.stringify(this.attributes, null, 2);
  }

  // TODO make this safe to override toJSON
  // https://github.com/remind101/r101-frontend/pull/3877#issuecomment-239017223
  recursivelyToJSON(): Object {
    const json = super.toJSON();

    const attrKeys = Object.keys(this.attributes);

    for (const key of attrKeys) {
      const val = this.get(key);

      if (val) {
        const jsonVal = Array.isArray(val) ? val.map((item) => serialize(item)) : serialize(val);
        json[key] = jsonVal;
      }
    }

    return json;
  }

  static fetch(attributes: any = {}, options: Backbone.ModelFetchOptions = {}): Promise<Entity> {
    return new this(attributes).fetch(options);
  }

  static fromJSON<T = Entity>(attributes: any = {}): T {
    return new this(attributes, { parse: true }) as any as T;
  }
}

function serialize(val: any): any {
  if (val instanceof Entity || val instanceof Collection) {
    return val.toJSON();
  } else {
    return val;
  }
}
